import { BodyText, Link } from '@farol-ds/react'
import { withTopbarProps } from '@jusbrasil/topbar'
import { withUserSession } from '@jusbrasil-web/shared-user-session'
import { getFirstQueryParam } from '@jusbrasil-web/shared-utils-url'
import { GetServerSideProps } from 'next'

import { AuthLayout, LoginCard } from '../../components'
import { ERROR_MESSAGES } from '../../utils/errorMessages'

export interface SSOErrorPageProps {
  reason?: string
}

export function SSOErrorPage(_props: SSOErrorPageProps) {
  const header = {
    title: ERROR_MESSAGES.sso.error.title,
  }

  return (
    <AuthLayout>
      <LoginCard header={header}>
        <div>
          <BodyText>{ERROR_MESSAGES.sso.error.message()}</BodyText>
          <div style={{ marginTop: '1rem' }}>
            <Link href="https://suporte.jusbrasil.com.br/hc/pt-br/sections/34361620998164-Parceria-Jusbrasil-e-CNJ">
              Ir para Central de Ajuda
            </Link>
          </div>
        </div>
      </LoginCard>
    </AuthLayout>
  )
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  return {
    props: {
      ...withTopbarProps(ctx),
      ...withUserSession(ctx),
      reason: getFirstQueryParam(ctx.query.reason) || null,
    },
  }
}

export const SSOErrorPageExports = {
  getServerSideProps,
}
